/**
 * Injects TawkTo plugin into React DOM
 */
class TawkTo {
  constructor(propertyId, widgetId, zIndex = null) {
    this.propertyId = propertyId;
    this.widgetId = widgetId;
    this.zIndex = zIndex;
    this.init();
  }

  /**
   * Initializes the TawkTo script and API object
   */
  init() {
    if (typeof window === 'undefined') return;

    // Ensure Tawk_API exists without overwriting existing instances
    window.Tawk_API = window.Tawk_API || {};
    window.Tawk_LoadStart = new Date();

    if (this.zIndex) {
      window.Tawk_API.customStyle = { zIndex: this.zIndex };
    }

    const id = '_t_a_w_k';
    if (document.getElementById(id) === null) {
      const element = document.createElement('script');
      element.id = id;
      element.async = true;
      element.src = `https://embed.tawk.to/${this.propertyId}/${this.widgetId}`;
      element.charset = 'UTF-8';
      element.setAttribute('crossorigin', '*');

      const firstScript = document.getElementsByTagName('script')[0];
      if (firstScript && firstScript.parentNode) {
        firstScript.parentNode.insertBefore(element, firstScript);
      } else {
        document.head.appendChild(element);
      }
    }
  }

  /**
   * Helper method to safely call Tawk_API methods
   * This prevents "is not a function" errors if the script isn't fully loaded
   */
  _callApi(method, ...args) {
    if (window.Tawk_API && typeof window.Tawk_API[method] === 'function') {
      return window.Tawk_API[method](...args);
    }
    console.warn(`Tawk_API.${method} is not yet available.`);
    return null;
  }

  /**
   * Callback function invoked right after the widget is rendered
   * @param {Function} callback
   */
  onLoad(callback) {
    window.Tawk_API.onLoad = callback;
  }

  /**
   * Maximizes the chat widget
   */
  maximize() {
    this._callApi('maximize');
  }

  /**
   * Minimizes the chat widget
   */
  minimize() {
    this._callApi('minimize');
  }

  /**
   * Toggles the chat widget state
   */
  toggle() {
    this._callApi('toggle');
  }

  /**
   * Opens the chat widget as a pop out
   */
  popup() {
    this._callApi('popup');
  }

  /**
   * Returns current page status (online, away, or offline)
   * @returns {string}
   */
  getStatus() {
    return this._callApi('getStatus') || 'offline';
  }

  /**
   * Set custom metadata regarding this chat/visitor
   * @param {Object} attribute
   * @param {Function} callback
   */
  setAttributes(attribute, callback) {
    this._callApi('setAttributes', attribute, callback);
  }
}

export default TawkTo;
